import { Icon, type IconProps } from "@chakra-ui/react"
import Logo from '@/assets/icons/KreozaWordmark.svg';

export const KreozaWordmark = ({
  color = "currentColor",
  bg,
  boxSize = "lg",
  ...props
}: IconProps & { bg?: string }) => {
  return (
    <Icon
      boxSize={boxSize}
      color={color}
      bg={bg}
      display="inline-flex"
      alignItems="center"
      justifyContent="center"
      verticalAlign="middle"
      {...props}
    >
      <Logo />
    </Icon>
  );
};


export const KreozaWordmarkReact = ({
  // color = "currentColor",
  // bg,
  // boxSize = "lg",
  // ...props
}: IconProps & { bg?: string }) => (
  // <Icon boxSize={boxSize} color={color} bg={bg} {...props}>

  <svg
    viewBox="0 0 100 20" // wider and taller for better scaling
    xmlns="http://www.w3.org/2000/svg"
    style={{
      height: "1em", // scales with surrounding text without pushing layout
      width: "auto",
      display: "inline-block",
      verticalAlign: "middle", // aligns with text baseline
    }}
  >
    <defs>
      <linearGradient id="grad" x1="0%" y1="0%" x2="100%" y2="0%">
        <stop offset="0%" stopColor="#FF6B6B" />
        <stop offset="50%" stopColor="#FFA84C" />
        <stop offset="100%" stopColor="#FFD93D" />
      </linearGradient>
    </defs>
    <text
      x="50%"
      y="50%"
      fontFamily="'Segoe UI', sans-serif"
      fontSize="36"
      fontWeight="bold"
      fill="url(#grad)"
      letterSpacing="2"
      textAnchor="middle"
      dominantBaseline="middle" // keeps vertical centering
    >
      Kreoza
    </text>
  </svg>
  // </Icon>
);